import Footer from '@/components/Footer'
import Header from '@/components/Header'
import { useHashRoute } from '@/lib/hashRouter'
import About from '@/pages/About'
import Blog from '@/pages/Blog'
import BlogPost from '@/pages/BlogPost'
import AcosConverter from '@/pages/calculators/AcosConverter'
import BreakEvenRoas from '@/pages/calculators/BreakEvenRoas'
import FacebookAdsRoas from '@/pages/calculators/FacebookAdsRoas'
import GoogleAdsRoas from '@/pages/calculators/GoogleAdsRoas'
import Contact from '@/pages/Contact'
import Faq from '@/pages/Faq'
import Home from '@/pages/Home'
import NotFound from '@/pages/NotFound'
import Privacy from '@/pages/Privacy'
import Terms from '@/pages/Terms'
import { Toaster } from 'react-hot-toast'

function App() {
  const [path, navigate] = useHashRoute()

  const renderPage = () => {
    if (path === '/') return <Home />
    if (path === '/calculators/break-even') return <BreakEvenRoas />
    if (path === '/calculators/google-ads') return <GoogleAdsRoas />
    if (path === '/calculators/facebook-ads') return <FacebookAdsRoas />
    if (path === '/calculators/acos-converter') return <AcosConverter />
    if (path === '/blog') return <Blog />
    if (path.startsWith('/blog/')) return <BlogPost slug={path.replace('/blog/', '')} />
    if (path === '/faq') return <Faq />
    if (path === '/about') return <About />
    if (path === '/contact') return <Contact />
    if (path === '/privacy') return <Privacy />
    if (path === '/terms') return <Terms />
    return <NotFound navigate={navigate} />
  }

  return (
    <div className="min-h-screen flex flex-col bg-slate-50 text-slate-600">
      <Toaster position="top-center" />
      <Header currentPath={path} navigate={navigate} />
      <main className="flex-1">{renderPage()}</main>
      <Footer navigate={navigate} />
    </div>
  )
}

export default App
